var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9hdfp994mc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8509",
    transform: "translate(517 6390)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h173v173H0z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "6ou7wm5jsd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46287",
    d: "M27.5 293.035a26.422 26.422 0 0 1 4.647-.878c3.712 0 10.313 5.383 14.478 8.046 6.262 4.023 8.415 5.468 12.58 5.468 5.695 0 7.508-3.258 7.508-3.258s-.963 1.162-4.193 1.162c-4.448 0-7.791-2.72-12.636-6.2-4.817-3.457-10.426-6.97-14.96-6.97-5.44 0-7.423 2.635-7.423 2.635",
    transform: "translate(-27.5 -290.4)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f2e9qv7p9f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9113",
    d: "M0 0h6.743v9.236H0z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "6coikwmt6g"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46288",
    d: "M92.4 310.543c.255.17.51.34.737.482 2.55 1.643 4.42 2.833 6.007 3.712V310.2a199.358 199.358 0 0 1-2.748-1.983 82.015 82.015 0 0 0-3.995-2.72z",
    transform: "translate(-92.4 -305.5)"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "edjgmii1li"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46289",
    d: "M97.5 296.408v11.73c0 4.023 4.023 3.485 4.023 3.485s.028-7.31.028-11.645.2-8.868 7.083-11.985a3.586 3.586 0 0 1 1.785-.227c.227 0 .453.028.68.028a12.3 12.3 0 0 1 5.128 1.048 11.343 11.343 0 0 0-8.16-3.343A10.766 10.766 0 0 0 97.5 296.408",
    transform: "translate(-97.5 -285.5)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "86b33w7f3j"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46290",
    d: "M33.056 268.628s7.253 4.222 7.82 5.5a7.59 7.59 0 0 1 .623 3.315c0 7.31-6.573 10.738-10.4 10.738a6.9 6.9 0 0 1-4.9-1.955 12.609 12.609 0 0 0 8.7 3.8 10.745 10.745 0 0 0 10.71-10.058 11.418 11.418 0 0 0-2.975-7.395c-2.947-3.627-7.423-3.967-9.01-3.967a5.053 5.053 0 0 0-.567.028",
    transform: "translate(-26.2 -268.6)"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bveljhhgsl"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46292",
    d: "M26.3 270.527a7.691 7.691 0 0 0 .453 1.813c.453 1.275.878 1.587 1.19 1.587a11.038 11.038 0 0 1 5.667-1.53 18.757 18.757 0 0 1 7.338 1.9 9.725 9.725 0 0 0-2.833-3.655A9.439 9.439 0 0 0 33.1 268.8a15.241 15.241 0 0 0-6.8 1.728",
    transform: "translate(-26.3 -268.799)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "6on7jg51sn"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46293",
    d: "M22.583 297.378c-.765.425-1.983 2.72-1.983 4.59a6 6 0 0 0 4.42 5.922 6.873 6.873 0 0 0 4.817-.2s-4.25-.652-4.25-5.723a7.084 7.084 0 0 1 2.89-5.27 7.577 7.577 0 0 0-2.267-.2 7.416 7.416 0 0 0-3.627.878",
    transform: "translate(-20.6 -296.5)"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "9cfsca7app"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46295",
    d: "M136.4 293.207c.028 0 5.1.765 5.1 5.751a6.185 6.185 0 0 1-3.542 5.95 10.712 10.712 0 0 0 5.695-.113c1.53-.482 2.692-2.833 2.692-5.5a7.819 7.819 0 0 0-2.153-5.213 6.74 6.74 0 0 0-4.137-1.388c-2.777-.028-3.655.51-3.655.51",
    transform: "translate(-136.4 -292.696)"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s65z5wfcme",
    x1: -2.136,
    y1: 8.105,
    x2: -2.084,
    y2: 8.105,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ad4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#f9a94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#f79b4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#f5854c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#f2674b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#ef4e49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#f15d48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#f47645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#f58644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68b43"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "tchwfgzjbh",
    x1: -14.248,
    y1: 9.858,
    x2: -13.944,
    y2: 9.858,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#a7a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#727575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#494c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#2b2f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#191d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#131718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#171b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#222626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#343839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#4f5253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#717374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#9a9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#cacbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ygibz40ffa",
    x1: -6.071,
    y1: 4.82,
    x2: -5.962,
    y2: 4.82,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee5143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#f37c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#fab04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#f7954a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ee5243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5143"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m5tuk6myvk",
    x1: -3.825,
    y1: 6.384,
    x2: -3.72,
    y2: 6.384,
    xlinkHref: "#ygibz40ffa"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "khadl14fcm",
    x1: -4.842,
    y1: 8.929,
    x2: -4.727,
    y2: 8.929,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a4498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#604b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#715da7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#8d7cb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9c8cc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#8472b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#6d59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#5f499b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a4498"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8uftvy8qtb",
    x1: -6.889,
    y1: 10.553,
    x2: -6.667,
    y2: 10.553,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292b66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#34346f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#504c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#7f73ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9c8cc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#7268a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4a4781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#32336d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292b66"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "mrpl7wblco",
    x1: -8.806,
    y1: 8.783,
    x2: -8.584,
    y2: 8.783,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292b66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2e2f6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#3d3c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#56518b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#796ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9c8cc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#9586be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#6f669e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#504c86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#3a3a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#2d2f6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292b66"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k6v9rokc0q",
    x1: -9.831,
    y1: 10.302,
    x2: -9.625,
    y2: 10.302,
    xlinkHref: "#8uftvy8qtb"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 156",
    transform: "translate(-517 -6390)",
    style: {
      clipPath: "url(#9hdfp994mc)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10359"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10358",
    transform: "translate(520.955 6467.329)",
    style: {
      clipPath: "url(#6ou7wm5jsd)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9111",
    style: {
      fill: "url(#s65z5wfcme)"
    },
    d: "M0 0h39.212v15.243H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10364"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10363",
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10362"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10361",
    style: {
      clipPath: "url(#f2e9qv7p9f)"
    },
    transform: "translate(539.343 6471.608)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10360",
    style: {
      clipPath: "url(#6coikwmt6g)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9112",
    style: {
      fill: "url(#tchwfgzjbh)"
    },
    d: "M0 0h6.743v9.236H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10366"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10365",
    transform: "translate(540.788 6465.941)",
    style: {
      clipPath: "url(#edjgmii1li)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9114",
    style: {
      fill: "url(#ygibz40ffa)"
    },
    d: "M0 0h18.728v26.633H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10368"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10367",
    transform: "translate(520.587 6461.153)",
    style: {
      clipPath: "url(#86b33w7f3j)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9115",
    style: {
      fill: "url(#m5tuk6myvk)"
    },
    d: "M0 0h19.408v21.419H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10370"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10369",
    transform: "translate(520.615 6461.209)",
    style: {
      clipPath: "url(#bveljhhgsl)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46291",
    d: "m20.8 258.575 14.9-4.675 2.89 9.208-14.931 4.675z",
    transform: "translate(-22.358 -258.121)",
    style: {
      fill: "url(#khadl14fcm)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10372"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10371",
    transform: "translate(519 6469.058)",
    style: {
      clipPath: "url(#6on7jg51sn)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9116",
    style: {
      fill: "url(#8uftvy8qtb)"
    },
    d: "M0 0h9.236v12.211H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10373"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46294",
    d: "M20.6 301.9c0-1.87 1.218-4.165 1.983-4.59a7.665 7.665 0 0 1 3.627-.878 6.363 6.363 0 0 1 2.238.227 7.084 7.084 0 0 0-2.89 5.27c0 5.072 4.25 5.723 4.25 5.723a5.516 5.516 0 0 1-2.522.51 9.186 9.186 0 0 1-2.295-.312 6.058 6.058 0 0 1-4.391-5.95 6 6 0 0 0 4.42 5.922 9.186 9.186 0 0 0 2.295.312 5.516 5.516 0 0 0 2.522-.51s-4.25-.652-4.25-5.723a7.084 7.084 0 0 1 2.89-5.27 6.569 6.569 0 0 0-2.238-.227 7.666 7.666 0 0 0-3.627.878c-.793.453-2.012 2.748-2.012 4.618z",
    transform: "translate(498.4 6172.629)",
    style: {
      fill: "url(#mrpl7wblco)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10375"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10374",
    transform: "translate(551.809 6467.98)",
    style: {
      clipPath: "url(#9cfsca7app)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9117",
    transform: "translate(0 -.027)",
    style: {
      fill: "url(#k6v9rokc0q)"
    },
    d: "M0 0h9.945v13.061H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10376"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46296",
    d: "M203.648 302.633h-3.117a1.661 1.661 0 0 1-1.247-1.7 3.891 3.891 0 0 1-1.3 1.247 6.39 6.39 0 0 1-5.383.2 3.64 3.64 0 0 1-2.012-4.335c.538-1.728 2.153-2.522 3.825-2.8a27.5 27.5 0 0 1 4.788-.2 2.469 2.469 0 0 0-.595-1.9c-.907-1.02-2.8-.907-4.023-.623a6.087 6.087 0 0 0-2.437 1.133l-.142-2.8a12.825 12.825 0 0 1 4.335-.85c1.728-.028 3.938.34 5.043 1.785a4.3 4.3 0 0 1 .822 2.493c.085 1.275.057 2.692.057 3.995v2.55c0 .085.028.142.028.227.142.992.6 1.5 1.36 1.587m-4.448-5.582a3.517 3.517 0 0 1-1.417 3.117c-1.19.793-3.542.822-3.853-.878a1.6 1.6 0 0 1 .623-1.53c1.1-.85 3.343-.765 4.647-.708",
    transform: "translate(376.692 6177.22)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46297",
    d: "M306.476 302.633h-3.116a1.661 1.661 0 0 1-1.247-1.7 3.89 3.89 0 0 1-1.3 1.247 6.45 6.45 0 0 1-5.412.2 3.64 3.64 0 0 1-2.012-4.335c.538-1.728 2.153-2.522 3.825-2.8a27.5 27.5 0 0 1 4.788-.2 2.469 2.469 0 0 0-.595-1.9c-.907-1.02-2.8-.907-4.023-.623a6.087 6.087 0 0 0-2.437 1.133l-.085-2.8a12.825 12.825 0 0 1 4.335-.85c1.728-.028 3.938.34 5.043 1.785a4.3 4.3 0 0 1 .822 2.493c.085 1.275.057 2.692.057 3.995v2.55c0 .085.028.142.028.227.142.992.6 1.5 1.332 1.587m-4.42-5.582a3.517 3.517 0 0 1-1.417 3.117c-1.19.793-3.542.822-3.853-.878a1.6 1.6 0 0 1 .623-1.53c1.077-.85 3.343-.765 4.647-.708",
    transform: "translate(303.018 6177.22)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46298",
    d: "M276.6 290.5h3.428v12.466c-2.1.113-3.485-.907-3.428-2.55z",
    transform: "translate(314.935 6176.858)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46299",
    d: "M275.777 269.147c-.142-.057-.283-.113-.34-.028a.763.763 0 0 1-.2.227c-.085.028.085.595.028.878 0 .113.085.085.113.113a.174.174 0 0 1 .028.2c.085.057.113.085.028.142-.057.085-.028.142 0 .227a.434.434 0 0 0 .2.283c.2.113.283.057.51.227a.9.9 0 0 1 .2.368c-.057.482.482.453.737.368.085-.028-.057-.113 0-.17.028-.028.113-.028.2-.057.255-.113.255-.085.255-.283 0-.113 0-.057.142-.085.085 0 0-.113.17-.085.142.057.142.028.142-.085 0-.142.142-.142.283-.113.34.085.085-.113.227-.113.255 0 .312-.028.538-.4a.511.511 0 0 0 .057-.283c.028-.17.085-.113.085-.255a.476.476 0 0 0-.113-.368 1.34 1.34 0 0 1-.2-.34 1 1 0 0 0-.255-.482 4.829 4.829 0 0 0-.538-.538 1.153 1.153 0 0 1-.255-.283c-.028-.028-.057-.057-.085-.057a2.812 2.812 0 0 0-.425-.085.187.187 0 0 0-.17.028c-.113.085-.028.057-.17.085-.057 0-.142.085-.2.142-.028.028-.057.028-.113.057-.113.113-.057.17-.2.17-.113 0-.113 0-.17.142-.028.085-.057.17-.17.17-.17 0-.057.028-.142.085-.028.028-.085 0-.113.028 0 .085 0 .17-.085.17",
    transform: "translate(315.924 6192.941)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46300",
    d: "M238.326 302.532a2.052 2.052 0 0 1 1.3-2.012 3.4 3.4 0 0 1 1.417.057 4.625 4.625 0 0 0 2.408-.255 1.057 1.057 0 0 0 .057-1.983c-1.02-.6-3.032-.765-4.278-1.87a3.116 3.116 0 0 1-1.048-2.55 3.641 3.641 0 0 1 2.578-3.2 10.62 10.62 0 0 1 6.262 0l-.2 2.408c-1.757-.623-3.938-.737-4.817.057a.887.887 0 0 0 .142 1.558c1.473.793 3.315.652 4.647 2.068a3.608 3.608 0 0 1-.17 4.845 5.453 5.453 0 0 1-3.513 1.388 14.771 14.771 0 0 1-4.788-.51",
    transform: "translate(342.467 6177.037)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46301",
    d: "M355.766 291.006c1.275.935 1.473 2.182 1.473 3.683.028 2.72.028 5.412.028 8.132-2.522.17-3.23-.85-3.315-1.757l-.028-4.392a6.6 6.6 0 0 0-.368-2.777 2.236 2.236 0 0 0-2.238-1.162 2.9 2.9 0 0 0-2.692 2.38 7.251 7.251 0 0 0-.17 1.757l-.057 5.808H345V290.3h3.2v1.927a4.864 4.864 0 0 1 2.607-1.842 5.755 5.755 0 0 1 4.958.623",
    transform: "translate(265.911 6177.145)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46302",
    d: "M456.976 302.633h-3.116a1.661 1.661 0 0 1-1.247-1.7 3.891 3.891 0 0 1-1.3 1.247 6.45 6.45 0 0 1-5.412.2 3.64 3.64 0 0 1-2.012-4.335c.538-1.728 2.153-2.522 3.825-2.8a27.5 27.5 0 0 1 4.788-.2 2.469 2.469 0 0 0-.6-1.9c-.907-1.02-2.8-.907-4.023-.623a6.087 6.087 0 0 0-2.437 1.133l-.085-2.8a12.825 12.825 0 0 1 4.335-.85c1.728-.028 3.938.34 5.043 1.785a4.3 4.3 0 0 1 .822 2.493c.085 1.275.057 2.692.057 3.995v2.55c0 .085.028.142.028.227.113.992.6 1.5 1.332 1.587m-4.42-5.582a3.517 3.517 0 0 1-1.417 3.117c-1.19.793-3.542.822-3.853-.878a1.6 1.6 0 0 1 .623-1.53c1.077-.85 3.343-.765 4.647-.708",
    transform: "translate(195.158 6177.22)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46303",
    d: "M491.7 290.5h3.428v12.466c-2.1.113-3.485-.907-3.428-2.55z",
    transform: "translate(160.779 6176.858)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46304",
    d: "M490.877 269.147c-.142-.057-.283-.113-.34-.028a.764.764 0 0 1-.2.227c-.085.028.085.595.028.878 0 .113.085.085.113.113a.174.174 0 0 1 .028.2c.057.057.113.085.028.142-.057.085-.028.142 0 .227a.434.434 0 0 0 .2.283c.2.113.283.057.51.227a.9.9 0 0 1 .2.368c-.057.482.482.453.737.368.085-.028-.057-.113 0-.17.028-.028.113-.028.2-.057.255-.113.255-.085.255-.283 0-.113 0-.057.142-.085.085 0 0-.113.17-.085.142.057.142.057.142-.085s.142-.142.283-.113c.34.085.085-.113.227-.113.255 0 .312-.028.538-.4a.511.511 0 0 0 .057-.283c.028-.17.085-.113.085-.255a.476.476 0 0 0-.113-.368 1.338 1.338 0 0 1-.2-.34 1 1 0 0 0-.255-.482 4.831 4.831 0 0 0-.538-.538 1.151 1.151 0 0 1-.255-.283c-.028-.028-.057-.057-.085-.057a2.814 2.814 0 0 0-.425-.085.187.187 0 0 0-.17.028c-.113.085-.028.057-.17.085-.057 0-.142.085-.2.142-.028.028-.057.028-.113.057-.113.113-.057.17-.2.17-.113 0-.113 0-.17.142-.028.085-.057.17-.17.17-.17 0-.057.028-.142.085-.057.028-.085 0-.113.028 0 .085 0 .17-.085.17",
    transform: "translate(161.768 6192.941)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46305",
    d: "M587.326 302.532a2.052 2.052 0 0 1 1.3-2.012 3.4 3.4 0 0 1 1.417.057 4.624 4.624 0 0 0 2.408-.255 1.057 1.057 0 0 0 .057-1.983c-1.02-.6-3.032-.765-4.278-1.87a3.116 3.116 0 0 1-1.048-2.55 3.641 3.641 0 0 1 2.578-3.2 10.62 10.62 0 0 1 6.261 0l-.2 2.408c-1.757-.623-3.938-.737-4.817.057a.887.887 0 0 0 .142 1.558c1.473.793 3.315.652 4.647 2.068a3.608 3.608 0 0 1-.17 4.845 5.453 5.453 0 0 1-3.513 1.388 14.845 14.845 0 0 1-4.788-.51",
    transform: "translate(92.348 6177.037)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46306",
    d: "M522.167 290.523c1.275.935 1.473 2.182 1.473 3.683l.057 5.893a2.173 2.173 0 0 0 1.9 2.21h-3.372c-1.388-.227-1.813-.992-1.87-1.7l-.028-4.392a6.6 6.6 0 0 0-.368-2.777 2.235 2.235 0 0 0-2.238-1.162 2.9 2.9 0 0 0-2.692 2.38 7.249 7.249 0 0 0-.17 1.757l-.057 5.808h-3.4v-12.38h3.2v1.927a4.864 4.864 0 0 1 2.607-1.842 5.666 5.666 0 0 1 4.958.595",
    transform: "translate(146.656 6177.487)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46307",
    d: "M563 277.779c-1.9-.113-3.343.963-3.343 2.465l-.057 9.066c-.028 2.663.907 3.995 2.578 4.477a8.184 8.184 0 0 0 4.136-.057l-.085-2.55c-1.955.482-3.2 0-3.2-1.87v-5.468h3.06v-2.437h-3.06v-3.627z",
    transform: "translate(112.114 6185.981)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46308",
    d: "M402.683 293.3a5.559 5.559 0 0 1-.2 5.128 2.823 2.823 0 0 1-4.335.368c-1.218-1.247-1.247-3.8-.425-5.27a2.864 2.864 0 0 1 4.958-.227m-5.327 7.253c-.028 1.813-.142 3.825-.113 5.723v.255c-.057.255-.142.17-.283.312a.68.68 0 0 0-.17.425c.085 1.3-.142 2.068-.113 3.343 0 .51-.34.453-.368.737a.571.571 0 0 1-.142.453v-1.275c-.085-.028-.057.283-.113.538-.028.142.028.34-.028.482a5.562 5.562 0 0 0-.085.68c-.028.113-.142.142-.17 0v-.482c-.085-.057-.142-.2-.17-.453v-1.3c-.2-.142-.2-.312-.142-1.02.085-.822.085-1.7.113-2.55a.286.286 0 0 0-.142-.227 20.025 20.025 0 0 0-.255 2.04.446.446 0 0 1 .113.368.992.992 0 0 0-.085.453.361.361 0 0 1-.2.34 13.053 13.053 0 0 1 .057-1.785v-2.493c-.17-.057-.085.312-.17.51 0 .312.028.425-.142.51-.142-1.3.057-2.153-.028-4.363 0-.057-.028-.227-.17-.227a50.5 50.5 0 0 1-.142 5.128 4.056 4.056 0 0 1-.028.822c-.028.113.085.453-.113.368-.085-.057-.142-.142-.085-.227.057-.113.113 0 .085-.312 0-.2.057-.312-.057-.453-.085-.113-.057-.255.028-.453a.7.7 0 0 0-.028-.538c-.057-.085.057-.085.057-.283.113-1.02-.255-.453-.17-1.473a5.239 5.239 0 0 0 .028-.68c.028-1.19 0-2.493.028-3.712 0-.142-.085-.2-.142-.085-.283.425-.2-.652-.2-.765a24.033 24.033 0 0 1 .142-4.193c0-.992-.028-2.012-.028-3-.142-.113-.17.227-.17.312v.113c0 .113-.17.142-.17.028 0-.057-.028-.085-.028-.142-.028-.51-.028-1.275.085-1.247.028-.85.057-1.445.283-1.587.142-.085.4-.085.453.113.057.113-.028.17.142.17a.552.552 0 0 0 .227-.028c.085-.028.057-.113.2-.085.227 0-.028.425.4.425.4 0 .34-.255.368-.453.028-.113.283-.113.34-.057.142.17-.057.17.283.17.793.028.935.453.907.822v1.048a5.381 5.381 0 0 1 8.528.34 8.471 8.471 0 0 1-.255 8.585c-1.785 2.38-6.176 2.89-8.16.34",
    transform: "translate(231.12 6177.855)",
    style: {
      fill: "#ee5143",
      fillRule: "evenodd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo2);
export default __webpack_public_path__ + "static/media/brand-logo-2.84f51a9a35a4e0aa0d1fc5522e24c8d6.svg";
export { ForwardRef as ReactComponent };